export type QueryValue = string | number | boolean | null | undefined;

export interface RequestOptions {
  /** Query string. `null`/`undefined` são omitidos; arrays viram chaves repetidas. */
  params?: Record<string, QueryValue | QueryValue[]>;
  headers?: Record<string, string>;
  signal?: AbortSignal;
  /** Timeout em ms (o padrão é definido pelo kernel). */
  timeoutMs?: number;
  /** Não anexar o token de sessão (endpoints públicos, ex.: login). */
  anonymous?: boolean;
  /** Lê a resposta como bytes, para arquivos. */
  responseType?: "json" | "blob";
  /**
   * Recebe status e cabeçalhos da resposta de sucesso (ex.: `X-Unread-Count`),
   * antes do corpo ser devolvido.
   */
  onResponse?: (response: { status: number; headers: Headers }) => void;
}

export interface IHttpClient {
  get<T>(url: string, options?: RequestOptions): Promise<T>;
  post<T>(url: string, body?: unknown, options?: RequestOptions): Promise<T>;
  put<T>(url: string, body?: unknown, options?: RequestOptions): Promise<T>;
  patch<T>(url: string, body?: unknown, options?: RequestOptions): Promise<T>;
  delete<T>(url: string, options?: RequestOptions): Promise<T>;
  /**
   * Cliente para outro serviço (outra baseURL) que reaproveita auth,
   * timeout e tratamento de erro. Substitui o `createInstance` do CadFrn,
   * que devolvia um Axios cru sem nenhum desses comportamentos.
   */
  withBaseUrl(baseUrl: string): IHttpClient;
}

/** Erro normalizado de qualquer resposta não-2xx, timeout ou falha de rede. */
export class HttpError extends Error {
  override readonly name = "HttpError";

  constructor(
    message: string,
    /** 0 = falha de rede/timeout. */
    readonly status: number,
    readonly url: string,
    readonly body?: unknown,
  ) {
    super(message);
  }

  get isNetworkError(): boolean {
    return this.status === 0;
  }
}

export function isHttpError(error: unknown): error is HttpError {
  return error instanceof HttpError;
}
